// extracted by mini-css-extract-plugin
module.exports = {"title":"RideSearchList_title__c2PdL"};